import { render, staticRenderFns } from "./MovieAnalyst.vue?vue&type=template&id=07a829b1&scoped=true&"
import script from "./MovieAnalyst.vue?vue&type=script&lang=js&"
export * from "./MovieAnalyst.vue?vue&type=script&lang=js&"
import style0 from "./MovieAnalyst.vue?vue&type=style&index=0&id=07a829b1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a829b1",
  null
  
)

export default component.exports